{"version":"26.10.27-local-solo","id":"at.softline.lagerhaus.eferding.softline","name":"Lagerhaus Eferding Softline"}